<template>
    <p>
        <span class="mode-livraison"><br/><strong>{{ libelle }}</strong></span>
        <span v-if="this.dateLibelle"><br/>Date de livraison souhaitée : {{ this.dateLibelle }}</span>
        <span v-if="this.scheduleInfos"><br/>Horaires : {{ this.scheduleInfos }}</span>
        <span v-if="this.infos"><br/>Indications : {{ this.infos }}</span>
        <span v-if="this.indicationsFDV"><br/><br/>Autres commentaires à l'attention de nos services :<br/><span class="indications">{{ this.indicationsFDV }}</span></span>
        <span v-if="this.commentaire"><br/>Commentaire du livreur : {{ this.commentaire }}</span>
    </p>    
</template>

<script>
import { mapState } from 'vuex'

import { actions } from '@/store/modesLivraison'

export default {

    props: {
        code: String,
        dateLibelle: String,
        scheduleInfos: String,
        infos: String,
        indicationsFDV: String,
        commentaire: String
    },

    computed: mapState({

        libelle ( state ) {

            let libelle = null
            state.modesLivraison.all.forEach(modeLivraison => {
                if ( modeLivraison.code ===  this.code ) {
                    libelle = modeLivraison.value
                }
            })

            if ( !libelle ) {
                libelle = "Mode de livraison " + this.code
            }

            return libelle
        }

    }),
  
    created () {
        this.$store.dispatch(actions.GET_ALL)
    }
}
</script>

<style scoped> 
.indications {
  white-space: pre-wrap;
  font-style: italic;
}

</style>